// extracted by mini-css-extract-plugin
module.exports = {"root":"CurrencyDropdown_root__Edwr6","portal":"CurrencyDropdown_portal__QmVPV","option":"CurrencyDropdown_option__c6v20"};